
import {
  Autocomplete,
  Button,
  FormControlLabel,
  Grid,
  Radio,
  RadioGroup,
  TextField,
  Typography,
} from "@mui/material";
import axios from "axios";
import React, { Fragment, memo, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { setSnackbar } from "../../../../../components/hooks/snackBar/reducers";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import _ from "lodash";
import CustomTable from "../customTable";
import moment from "moment";
import { Helmet } from "react-helmet-async";
import { CSVLink } from "react-csv";

const HighSalesVendorReport = () => {
  const dispatch = useDispatch();

  const pageOption = [10, 25, 50, 100];

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(pageOption[0]);
  const [pageCount, setPageCount] = useState(0);

  const [data, setData] = useState([]);
  const [supplier, setSupplier] = useState([]);
  const [catData, setCatData] = useState([]);
  const [subData, setSubData] = useState([]);
  const [allSubData, setAllSubData] = useState([]);

  const [totalAmount, setTotalAmount] = useState(0);
  const [totalFlag, setTotalFlag] = useState(false);

  const [dateLimit, setDateLimit] = useState({
    fromDate: moment().startOf("month").format(),
    toDate: moment().format(),
  });

  const [options, setOptions] = useState({
    category: null,
    subCategory: null,
    vendor: null,
  });
  const [reportType, setReportType] = useState("category"); 

  // const columns = [
  //   { field: "sno", headerName: "Rank", minWidth: 80,  },
  //   { field: "supplier", headerName: "Vendor", flex: 1, },
  //   { field: "outlet", headerName: "Outlet", flex: 1, },
  //   { field: "category", headerName: "Category", flex: 1, },
  //   { field: "subcategory", headerName: "Sub Category", flex: 1, },
  //   {
  //     field: "units",
  //     headerName: "Units Sold",
  //     flex: 1,
  //     renderCell: (params) => <strong>{params.value}</strong>,
  //   },
  // ];

  const columns =
  reportType === "category"
    ? [
        { field: "sno", headerName: "Rank", minWidth: 80 },
        { field: "supplier", headerName: "Vendor", flex: 1 },
        { field: "outlet", headerName: "Outlet", flex: 1 },
        { field: "category", headerName: "Category", flex: 1 },
        { field: "subcategory", headerName: "Sub Category", flex: 1 },
        { field: "units", headerName: "Units Sold", flex: 1 },
      ]
    : [
        { field: "sno", headerName: "Rank", minWidth: 80 },
        { field: "supplier", headerName: "Vendor", flex: 1 },
        { field: "product", headerName: "Item", flex: 1 },
        { field: "category", headerName: "Category", flex: 1 },
        { field: "subcategory", headerName: "Sub Category", flex: 1 },
        { field: "units", headerName: "Units Sold", flex: 1 },
      ];

  const rows = _.map(data, (val, idx) => ({
    id: `${val.outlet_id}-${val.subcategory_name}-${page}-${idx}`, 
    sno: val.sales_rank,
    supplier: val.supplier_name,
    product: val.product_name,
    outlet: val.outlet_name,
    category: val.category_name,
    subcategory: val.subcategory_name,
    units: val.units_sold,
  }));

  const props = {
    columns,
    rows,
    page,
    setPage,
    rowsPerPage,
    setRowsPerPage,
    pageCount,
    pageOption,
    totalAmount,
    totalFlag,
  };
  useEffect(() => {
    setTotalFlag(true);
    let total = 0;
    data.forEach((val) => {
      total += parseFloat(val.units_sold || 0);
    });
    setTotalAmount(total.toFixed(0));
  }, [data]);

  function handleOptions(value, name) {
    setOptions((prev) => ({ ...prev, [name]: value }));
    setPage(0); 

    if (name === "category") {
      setOptions((prev) => ({ ...prev, subCategory: null }));
      filterSubCategories(value ? value.id : null);
    }
  }

  function filterSubCategories(categoryId) {
    if (categoryId) {
      const filtered = allSubData.filter(
        (sub) => sub.category_id === categoryId
      );
      setSubData(filtered);
    } else {
      setSubData([]);
    }
  }

  function handleChange(e, name) {
    setPage(0); 
    setDateLimit((prev) => ({
      ...prev,
      [name]: dayjs(e).format(),
    }));
  }
  function handleOutletSalesItemWise() {
    const postData = {
      from_date: moment(dateLimit.fromDate).format("YYYY-MM-DD"),
      to_date: moment(dateLimit.toDate).format("YYYY-MM-DD"),
      vendor_id: options.vendor?.id || 0,
      main_cat_id: options.category?.id || 0,
      sub_cat_id: options.subCategory?.id || 0,
      page_size: rowsPerPage,
      current_page: page + 1,
    };

    const url =
    reportType === "category"
      ? "/v1/reports/sales/ranking"
      : "/v1/reports/sales/ranking/item";

    axios
      // .post(`/v1/reports/sales/ranking`, postData)
       .post(url, postData)
      .then((res) => {
        setData(res.data?.data || []);
        setPageCount(res.data?.meta?.pagination?.total || 0);
      })
      .catch((err) => {
        setData([]);
        dispatch(
          setSnackbar(
            true,
            "error",
            err.response?.data?.message || "No Data Found"
          )
        );
      });
  }

  function handleReset() {
  setOptions({
    category: null,
    subCategory: null,
    vendor: null,
  });

  setDateLimit({
    fromDate: moment().startOf("month").format(),
    toDate: moment().format(),
  });

  setReportType("category"); // default
  setPage(0);
  setData([]);
}

  useEffect(() => {
    axios.get("/v1/supplier").then((res) => setSupplier(res.data));
    axios
      .get("/v1/categories")
      .then((res) =>
        setCatData(res.data.filter((val) => val.is_active))
      );
    axios.get("/v1/subcategories").then((res) => setAllSubData(res.data));
  }, []);

  useEffect(() => {
    if (dateLimit.fromDate && dateLimit.toDate) {
      handleOutletSalesItemWise();
    }
  }, [
    page,
    rowsPerPage,
    dateLimit.fromDate,
    dateLimit.toDate,
    options.vendor,      
    options.category,
    options.subCategory,
    reportType
  ]);

  const generateCSVData = () => {
    const csvData = [
      ["Vendor", options.vendor ? options.vendor.name : "All"],
      ["From Date", moment(dateLimit.fromDate).format("YYYY-MM-DD")],
      ["To Date", moment(dateLimit.toDate).format("YYYY-MM-DD")],
      [],
      // ["Rank", "Vendor", "Outlet", "Category", "Sub Category", "Units"],
      reportType === "item"
  ? ["Rank", "Vendor", "Item", "Category", "Sub Category", "Units"]
  : ["Rank", "Vendor", "Outlet", "Category", "Sub Category", "Units"],
    ];

    rows.forEach((row) => {
      csvData.push([
        row.sno,
        row.supplier,
        // row.outlet,
        reportType === "item" ? row.product : row.outlet,
        row.category,
        row.subcategory,
        row.units,
      ]);
    });

    csvData.push([]);
    csvData.push(["", "", "", "", "Total Units", totalAmount]);

    return csvData;
  };
  return (
    <Fragment>
      <Helmet>
        <title>High Sales Vendor Reports</title>
      </Helmet>

      <Typography variant="h6">High Sales Vendor Reports</Typography>

      <Grid container spacing={2} className="p-2 pt-2">
        <Grid item md={3}>
          <Autocomplete
            size="small"
            value={options.vendor}
            options={supplier}
            getOptionLabel={(option) => option?.name || ""}
            isOptionEqualToValue={(o, v) => o?.id === v?.id}
            onChange={(e, value) => handleOptions(value, "vendor")}
            renderInput={(params) => (
              <TextField {...params} label="Supplier" />
            )}
          />
        </Grid>

        <Grid item md={3}>
          <Autocomplete
            size="small"
            value={options.category}
            options={catData}
            getOptionLabel={(o) => o.category_name}
            onChange={(e, v) => handleOptions(v, "category")}
            renderInput={(params) => (
              <TextField {...params} label="Category" />
            )}
          />
        </Grid>

        <Grid item md={3}>
          <Autocomplete
            size="small"
            value={options.subCategory}
            options={subData}
            disabled={!options.category}
            getOptionLabel={(o) => o.subcategory_name}
            onChange={(e, v) => handleOptions(v, "subCategory")}
            renderInput={(params) => (
              <TextField {...params} label="Sub Category" />
            )}
          />
        </Grid>

        <Grid item md={3}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              value={dayjs(dateLimit.fromDate)}
              onChange={(e) => handleChange(e, "fromDate")}
              format="DD-MM-YYYY"
              slotProps={{
                textField: { size: "small", label: "From", fullWidth: true },
              }}
            />
          </LocalizationProvider>
        </Grid>

        <Grid item md={3}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              value={dayjs(dateLimit.toDate)}
              onChange={(e) => handleChange(e, "toDate")}
              format="DD-MM-YYYY"
              slotProps={{
                textField: { size: "small", label: "To", fullWidth: true },
              }}
            />
          </LocalizationProvider>
        </Grid>

        <Grid item md={3}>
  <RadioGroup
    row
    value={reportType}
    onChange={(e) => {
      setReportType(e.target.value);
      setPage(0);
    }}
  >
    <FormControlLabel
      value="category"
      control={<Radio />}
      label="CategoryWise"
    />
    <FormControlLabel
      value="item"
      control={<Radio />}
      label="ItemWise"
    />
  </RadioGroup>
</Grid>

        {/* <Grid item md={3} style={{ display: "flex", justifyContent: "end" }}>
          <CSVLink
            data={generateCSVData()}
            filename={"HighSalesVendor_Reports.csv"}
          >
            <Button variant="contained">Download CSV</Button>
          </CSVLink>
        </Grid> */}
        <Grid item md={3} style={{ display: "flex", gap: "10px", justifyContent: "end" }}>
  
  {/* ✅ Reset Button */}
  <Button
    variant="contained"
    color="secondary"
    onClick={handleReset}
  >
    Reset
  </Button>

  {/* CSV Download */}
  <CSVLink
    data={generateCSVData()}
    // filename={"HighSalesVendor_Reports.csv"}
    filename={
  reportType === "item"
    ? "ItemWise_Report.csv"
    : "CategoryWise_Report.csv"
}
  >
    <Button variant="contained">Download CSV</Button>
  </CSVLink>

</Grid>
      </Grid>

      <CustomTable props={props} />
    </Fragment>
  );
};

export default memo(HighSalesVendorReport);
